import { Card, Dropdown, FloatButton, Pagination } from 'antd'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { deleteAbonement, getAbonementsList, getAbonementsListClubs } from 'src/store/Slices/AbonementsSlice'
import AddNewAbonement from '../Modals/AddNewAbonement'
import EditNewAbonement from '../Modals/EditNewAbonement'
import SureModal from 'src/components/Modals/SureModal'
import { openNotification } from 'src/components/helpers/notification'
import { DownOutlined, PlusOutlined } from '@ant-design/icons';

const MobileAbonements = ({
    abonementsList,
    abonementsListLoading,
    setTab,
    abonementInfo,
    setAbonementInfo,
    mnemo
}) => {

    const dispatch = useDispatch()
    const items = [
        {
            key: '1',
            label: 'Редактировать',
            onClick: () => { setIsEditOpenModal(true) },
            disabled: (!mnemo?.children?.find(el => el.name === 'Справочник')?.children.find(ele => ele.mnemo === 'updateBtn'))
        },
        {
            key: '2',
            label: 'Удалить',
            onClick: () => { setIsOpenDeleteModal(true) },
            disabled: (!mnemo?.children?.find(el => el.name === 'Справочник')?.children.find(ele => ele.mnemo === 'deleteBtn'))
        },
    ];

    const [isOpenModal, setIsOpenModal] = useState(false)
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
    const [isOpenEditModal, setIsEditOpenModal] = useState(false)

    const onClickDelete = () => {
        dispatch(deleteAbonement({
            abonementId: abonementInfo.id
        })).then(() => {
            openNotification({
                type: 'success',
                message: `Абонемент успешно удален`
            })
            dispatch(getAbonementsList())
            setIsOpenDeleteModal(false)
        })
    }

    return (
        <>
            <AddNewAbonement
                visible={isOpenModal}
                setVisible={setIsOpenModal}
            />
            <EditNewAbonement
                visible={isOpenEditModal}
                setVisible={setIsEditOpenModal}
                abonementInfo={abonementInfo}
            />
            <SureModal
                visible={isOpenDeleteModal}
                setVisible={setIsOpenDeleteModal}
                onClickYes={onClickDelete}
            />
            {abonementsList?.data?.value?.rows.map(element => {
                return (
                    <Card
                        loading={abonementsListLoading}
                        title={`Абонемент №: ${element.id}`}
                        extra={<Dropdown
                            menu={{
                                items,
                            }}
                        >
                            <a onClick={() => { setAbonementInfo(element) }} className="text-primary text-decoration-none">
                                Действия <DownOutlined />
                            </a>
                        </Dropdown>}
                        style={{ width: 330, marginTop: 16 }}
                        actions={[
                            <div onClick={() => {
                                setAbonementInfo(element)
                                dispatch(getAbonementsListClubs({ AbonementId: element.id }))
                                setTab('Стоимость пакета')
                            }}>Стоимость пакета</div>,
                        ]}
                        key={element.id}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div>
                                <div>№:</div>
                                <div>Наименование:</div>
                                <div>Код изображения:</div>
                                <div>Тип:</div>
                            </div>
                            <div>
                                <div>{element?.id ? element?.id : '-'}</div>
                                <div>{element?.name ? element?.name : '-'}</div>
                                <div>{element?.code ? element?.code : '-'}</div>
                                <div>{element?.typeName ? element?.typeName : '-'}</div>
                            </div>
                        </div>
                    </Card>
                )
            })}
            <FloatButton
                disabled={(!mnemo?.children?.find(el => el.name === 'Справочник')?.children.find(ele => ele.mnemo === 'insertBtn'))}
                style={{ right: 24 }}
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                    setIsOpenModal(true)
                }}
            />
        </>
    )
}

export default MobileAbonements